module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/19-8446eddd83452c119dd52c4cf47cd112.jpg";